export const displayModificationContainerSelector = ({displayModificationContainer}) => displayModificationContainer